import { environment } from '../../environments/environment';

export const chimeraApiConfig = environment.chimeraApi;
